import React, { PropTypes } from 'react';
import config from 'config';
import IconButton from 'material-ui/IconButton';
import IconClose from '../../Icons/IconClose';
import RaisedButton from 'material-ui/RaisedButton';
import IconFaceBook from '../../Icons/IconFaceBook';
import InputCheckbox from '../../form/InputCheckbox';
import Input from '../../form/Input';
import RichEditor from '../../form/RichEditor';
import ImageUpload from '../../form/ImageUpload';
import ExternalVideoInput from '../../form/ExternalVideoInput';
import {
  NewsImageContent,
  NewsAWSContent,
  NewsLinkContent
} from '../../../api/news/news';
import { VideoInput } from '../../form/VideoInput';
import RadioGroup from '../../form/RadioGroup';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';
import { Container, Row, Col } from 'react-grid-system';

const NEWS_CONTENT_TYPE = [
  {
    label: 'Image',
    value: NewsImageContent
  },
  {
    label: 'Video',
    value: NewsAWSContent
  },
  {
    label: 'YouTube/Vimeo',
    value: NewsLinkContent
  }
];

class NewsEditForm extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    goIndex: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    publish: PropTypes.func.isRequired,
    share: PropTypes.func.isRequired,
    onCloseEditForm: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired
  };

  state = {
    shareFacebook: false
  };

  componentWillUnmount() {
    this.props.onCloseEditForm();
  }

  async save(data) {
    let { shareFacebook } = data;
    let res = await this.props.save(this.props.model, data);

    this.props.fields.shareFacebook.onChange(shareFacebook);
    return res;
  }

  publish = () => {
    let { handleSubmit, save, model, share, publish, goIndex } = this.props;
    return handleSubmit(async data => {
      await save(model, data);
      if (this.state.shareFacebook) {
        await share(model);
      }
      await publish(model);
      return goIndex();
    })();
  };

  processSubmit = () => {
    let { handleSubmit, save, model } = this.props;
    return handleSubmit(async data => {
      await save(model, data);
    })();
  };

  render() {
    let {
      fields: { title, content, typeContent, image },
      pristine,
      disabled,
      goIndex,
      valid,
      submitting
    } = this.props;
    const { shareFacebook } = this.state;

    let {} = config.newsCrop;

    return (
      <Container style={{ marginLeft: 0 }}>
        <Row>
          <Col lg={8} md={10} xs={12}>
            <form onSubmit={this.processSubmit} style={{ padding: 16 }}>
              <LoggedAppBar
                isStatic={true}
                title={this.props.title}
                iconElementRight={
                  <IconButton onClick={goIndex}>
                    <IconClose />
                  </IconButton>
                }
              />

              <RadioGroup
                inline={false}
                options={NEWS_CONTENT_TYPE}
                {...typeContent}
              />
              <Input label="Add News Title" required {...title} />

              <ImageUpload
                label={
                  typeContent.value === NewsImageContent
                    ? 'Add News Photo'
                    : 'Add Preview Video Photo'
                }
                required
                imageWidth="auto"
                imageHeight="300px"
                crop={config.newsCrop}
                {...image}
              />

              {this._renderContent()}

              <RichEditor label="Add News Text" required {...content} />
              <Row>
                <Col sm={8}></Col>
                <Col xs={12} sm={4}>
                  <InputCheckbox
                    labelStyle={{ alignItems: 'center' }}
                    label={
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div>Share with</div>
                        <IconFaceBook style={{ marginLeft: 17 }} />
                      </div>
                    }
                    checked={shareFacebook}
                    onCheck={() => {
                      this.setState({ shareFacebook: !shareFacebook });
                    }}
                  />
                </Col>
              </Row>
              <br />
              <Row>
                <Col xs={12} sm={6}>
                  <RaisedButton
                    secondary={true}
                    fullWidth={true}
                    disabled={!valid || submitting || pristine || disabled}
                    onClick={this.processSubmit}
                    label="Save"
                  />
                </Col>
                <Col xs={12} sm={6}>
                  <RaisedButton
                    primary={true}
                    fullWidth={true}
                    disabled={!valid || submitting}
                    onClick={this.publish}
                    label="Save and Publish"
                  />
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    );
  }

  _renderContent() {
    let {
      fields: { typeContent, video, link, image }
    } = this.props;

    switch (typeContent.value) {
      case NewsAWSContent:
        return (
          <VideoInput
            label="Upload video"
            allowedFormats={config.allowedFormats}
            required
            screenShotImageSize={config.newsCrop}
            onScreenShotImage={async screenShot => {
              image.onChange(screenShot);
            }}
            {...video}
          />
        );
      case NewsLinkContent:
        return (
          <ExternalVideoInput label="Add link to video" required {...link} />
        );
    }
  }
}

export default NewsEditForm;



// WEBPACK FOOTER //
// ./src/components/News/NewsEditForm/NewsEditForm.jsx